import React, { PropTypes, Component } from 'react';

import { Link } from 'react-router';

import * as routes from '../../../routes/const';

import { NitroHeading, NitroButton, NitroParagraph, NitroPanel } from 'nitro-components';

import Header from "../../../components/layouts/Header";

class QuoteDeclined extends Component {
  constructor(props, context) {
    super(props, context);
    this.startQuoteAgain = this.startQuoteAgain.bind(this);
  }

  startQuoteAgain() {
    const { router } = this.context;
    router.push(routes.CQ_CREATE_QUESTIONS);
  }

  render() {
    return (
      <div>

        <Header margin="32px 0" lineHeight={32}>
          <NitroHeading label="Cannot complete quote" align="center" size="1" />
        </Header>

        <NitroPanel padding="48px 24px">
          <NitroParagraph align="center">
            Based on the information you provided, it looks like you may not be eligible for a company vehicle at this time.
          </NitroParagraph>
          <NitroParagraph align="center">Please contact us on 1800 818 625 if you have any questions.</NitroParagraph>
          <br />
          <NitroParagraph align="center">
            <NitroButton label="Start a new quote" variant="primary" action={() => this.startQuoteAgain()} />
          </NitroParagraph>
          <NitroParagraph align="center">
            <Link to={routes.HOME}>Back to home</Link>
          </NitroParagraph>
        </NitroPanel>

      </div>
    );
  }
}

QuoteDeclined.contextTypes = {
  router: PropTypes.object
};

export default QuoteDeclined;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/QuoteDeclined.js